<div class="col-xl">
    <form id="formService" [formGroup]="form">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Crear solicitud</h4>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row g-3">
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Fecha de Solicitud</b></h6>
                            <label class="form-label">{{ now | date:'dd/MM/yyyy' }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Hora de solicitud</b></h6>
                            <label class="form-label">{{ now | date:'HH:mm' }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Usuario</b></h6>
                            <label class="form-label">{{dataUser.name}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Unidad</b></h6>
                            <label class="form-label">{{unit.unit}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Placas</b></h6>
                            <label class="form-label">{{unit.plates}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">¿Como clasificas la solicitud de mantenimiento? Selecciona una opción:</h4>
            </div>
            <div class="card-body mt-0 pb-1">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12 d-flex">
                            <div *ngFor="let item of priority" class="ms-2">
                                <input type="radio" class="btn-check" formControlName="priority_id" name="priority_id"
                                    id="btn-check{{item.id}}" [value]="item.id" autocomplete="off">
                                <label class="btn btn-primary btn-priority"
                                    for="btn-check{{item.id}}">{{item.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body mt-0 mb-0 pt-0">
                <div class="d-flex justify-content-center justify-content-md-end gap-2">
                    <a class="btn btn-outline-primary btn-action" (click)="onCancel()">Cancelar</a>
                    <button type="button" class="btn btn-primary btn-action" [disabled]="form.invalid || submitting"
                        (click)="onSubmit()">
                        {{ submitting ? 'Enviando...' : 'Crear solicitud' }}
                    </button>
                </div>
            </div>
        </div>
    </form>

    <ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
        <div class="loader"></div>
        <p style="font-size: 20px; color: white">{{text_loading}}</p>
    </ngx-spinner>

</div>
